import React from "react";
import Lottie from "react-lottie";
import uploadLottie from "./lottie/upload-media.json";

export default function FileUploadAnimation({ color, size }) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: uploadLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return <Lottie options={defaultOptions}  isStopped={false} isPaused={false} />;
}
